import { createTheme } from '@mui/material/styles';

const theme = createTheme({
   root: {
    margin: 'auto',
    flexGrow: 1,
    width: '80%',
    marginTop: '2%',
    marginBottom: '5%',
  },
 
  header: {
    fontWeight: 900,
  },
  darkHeader: {
    background: '#1A2226',
    color: '#ffffff',
    padding: '.5em',
    borderRadius: '.15em',
  },
  palette: {
    primary: 
      { 
        main: '#42555E', //gray text for body copy
        light: '#F2F3F4', //gray backgrounds, headers, highlights, selected states
        dark: '#1A2226', //almost black text for headlines,
        contrastText: '#fff',
      },
    secondary: 
      {
        main: '#BE161D', //LS dark red, text links
        light: '#ED1C24', //LS red buttons, headlines, accents
      },
    error: 
      {
        main: '#ED1C24', //LS red text
      },
    warning: 
      {
        main: '#FDC203', //LS yellow accent elements
      },
    info: 
      {
        main: '#065386', //LS blue for text
      },
    success: 
      {
        main: '#379811', //green for text
        light: '#41B314', //light green for form elements
      },
    white: {
      main: '#FFFFFF',
    }
  },
})

export default theme;